import { useQuery } from '@tanstack/react-query';
import { useProvider } from 'utils/providers/Provider';
import { Api } from 'hooks';

import c from '../utils/constants';

type Params = {
  id: string;
  month: number;
  year: number;
  requestingTimezone: string;
  requestCurrentUnixTime: number;
};

type Response = {
  dates: {
    date: string;
    timezone: string;
    times: {
      bookingTime: string;
      bookingDate: string;
      bookingTimezone: string;

      convertedTime: string;
      convertedDate: string;
      convertedTimezone: string;

      unix: number;
    }[];
  }[];
};

const useGetBookingAvailabilityDatesAndTimes = (params: Params) => {
  const { id, month, year, requestCurrentUnixTime, requestingTimezone } =
    params;
  const { state } = useProvider();
  const args = state;
  return useQuery<Response>({
    queryKey: [c.BOOKING_EVENT_AVAILABILITY_DATE_TIME, id, month, year],
    queryFn: async () => {
      const api = new Api(args);

      const data = await api.get({
        url: `api/public/calendar/bookings/events/${id}/datetimes`,
        params: { month, year, requestCurrentUnixTime, requestingTimezone },
      });

      return data?.data;
    },
    enabled: !!id && !!month && !!year,
    retry: false,
  });
};

export default useGetBookingAvailabilityDatesAndTimes;
